import { render, staticRenderFns } from "./topicGoodsModal.vue?vue&type=template&id=fdfe1ed6&scoped=true"
import script from "./topicGoodsModal.vue?vue&type=script&lang=js"
export * from "./topicGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./topicGoodsModal.vue?vue&type=style&index=0&id=fdfe1ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe1ed6",
  null
  
)

export default component.exports